import React from 'react';
import type { EntryPointProps } from 'react-relay';
import { TrialBanner, type TrialBannerProps } from './main';

export const TrialBannerEntrypointContainer = ({
	props: { isProjectSimplified },
}: EntryPointProps<{}, {}, TrialBannerProps, {}>) => (
	<TrialBanner isProjectSimplified={isProjectSimplified} />
);

export default TrialBannerEntrypointContainer;
